'use client';

import { Box, CircularProgress, Typography } from '@mui/material';

export default function Loading() {
	return (
		<Box
			sx={{
				// The themed page background from globals.css — a literal hex here flashes light
				// on a dark-mode hard load. In-app navigation shows GlobalTopLoader instead; this
				// is only the initial-load streaming fallback, before any JS is running.
				bgcolor: 'var(--bg-page)',
				minHeight: '100vh',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				gap: 2
			}}>
			<CircularProgress color="lumoraGreenPrimary" size={40} />
			<Typography variant="body2" color="text.secondary">
				Loading...
			</Typography>
		</Box>
	);
}
